<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">子机构管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="5" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="top_box">
                    <div class="company_box flex-box">
                        <img :src="userInfo.institution.avatar" class="company_img" alt="" />
                        <div class="flex-grow-1">
                            <div class="flex-box">
                                <div class="company_name fs28 fwb">{{ userInfo.institution.company_name }}</div>
                                <i class="vip1"></i>
                            </div>
                            <router-link class="fs16 col12 underline" :to="'/IncomeDetail?id='+userInfo.id">积分收益：{{ userInfo.institution.score }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="bottom_box">
                    <div class="flex-box flex-between plr44">
                        <div class="input_box flex-box">
                            <input type="text" class="flex-grow-1 fs14" placeholder="搜索我的订单" v-model="query.keyword" />
                            <div class="cursor search_btn fs14" @click="searchOrder">搜索</div>
                        </div>
                        <router-link to="/SubManage" class="back fs16 col12 cursor flex-box">返回</router-link>
                    </div>
                    <div class="flex-box fs16 mt30 mb30 plr44">
                        <div class="col90 mr30">订单类型:</div>
                        <!-- <div class="type"><span>全部</span></div> -->
                        <div class="type" :class="query.order_type == 'general' ? 'active' : ''"
                            @click="onActivityChange('general')"><span>商城订单</span></div>
                        <div class="type" :class="query.order_type == 'activity' ? 'active' : ''"
                            @click="onActivityChange('activity')"><span>活动订单</span></div>
                    </div>
                    <div class="flex-box fs16 mb25 plr44" v-if="query.order_type == 'activity'">
                        <div class="col90 mr30">活动类型:</div>
                        <div class="type" v-for="(item, index) in searchData.activity" :key="index"
                            @click="onShift(item.value)" :class="activityType == item.value ? 'active' : ''">
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                    <div class="condition_box">
                        <div class="flex-box order_status fs14 col04 plr44">
                            <div class="item" v-for="(item, index) in tab" :key="index" @click="chooseNav(item.id)"
                                :class="item.id == query.type ? 'active' : ''">{{ item.name }}</div>
                            <div @click="filter = !filter" class="sort flex-box flex-center colf fs14 cursor" :class="filter?'on':''">筛选</div>
                        </div>
                        <div v-if="filter" class="pb20">
                            <div class="flex-box fs14 plr44 mt20">
                                <div class="col90 mr90">订单时间</div>
                                <div class="select_box relative">
                                    <div class="flex-box select fs14 cursor" @click="showStart = !showStart">
                                        <div class="flex-grow-1" :class="startIndex == -2 ? 'col90' : ''">{{ startIndex ==
                                            -2 ? '请选择' : startIndex == -1 ? '全部' : searchData.dates[startIndex].name }}
                                        </div>
                                    </div>
                                    <div class="data_list" :class="showStart ? 'show' : ''">
                                        <div class="item fs14 cursor" @click="dateChange(-1)">全部</div>
                                        <div class="item fs14 cursor" v-for="(item, index) in searchData.dates" :key="index"
                                            @click="dateChange(index)">{{ item.name }}</div>
                                    </div>
                                </div>
                                <template v-if="startIndex >= 0">
                                    <div class="date_picker fs14">
                                        <input class="input_time" v-model="dates.start" type="date" @click="openDatePicker">
                                        <div :class="dates.start == '' ? 'col7a' : ''">
                                            {{ dates.start == '' ? '自定最早时间' : dates.start }}
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                    <div class="date_picker fs14">
                                        <input class="input_time" v-model="dates.end" type="date" @click="openDatePicker">
                                        <div :class="dates.end == '' ? 'col7a' : ''">
                                            {{ dates.end == '' ? '自定最终时间' : dates.end }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="flex-box fs14 mt20 mb20 plr44 h40">
                                <div class="col90 mr90">价格排序</div>
                                <div class="type" :class="priceIndex == 0 ? 'active' : ''" @click="priceSort(0)">
                                    <span>全部</span>
                                </div>
                                <div class="type" :class="priceIndex == 1 ? 'active' : ''" @click="priceSort(1)">
                                    <span>由高到低</span>
                                </div>
                                <div class="type" :class="priceIndex == 2 ? 'active' : ''" @click="priceSort(2)">
                                    <span>由低到高</span>
                                </div>
                            </div>
                            <div class="flex-box fs14 pl152">
                                <input class="date_picker fs14" :class="minprice == '' ? 'col7a' : ''" v-model="minprice"
                                    placeholder="自定最低价格" type="number" />
                                <div class="line"></div>
                                <input class="date_picker fs14" :class="maxprice == '' ? 'col7a' : ''" v-model="maxprice"
                                    placeholder="自定最高价格" type="number" />
                            </div>
                            <div class="flex-box fs14 mt20  plr44">
                                <div class="col90 mr90">时间排序</div>
                                <div class="type" :class="timeIndex == 0 ? 'active' : ''" @click="timeSort(0)">
                                    <span>全部</span>
                                </div>
                                <div class="type" :class="timeIndex == 1 ? 'active' : ''" @click="timeSort(1)">
                                    <span>由近及远</span>
                                </div>
                                <div class="type" :class="timeIndex == 2 ? 'active' : ''" @click="timeSort(2)">
                                    <span>由远及近</span>
                                </div>
                                <div class="go shai fs14 cursor" @click="searchSiftConfirm">去筛选</div>
                            </div>
                            <div class="flex-box flex-col-start flex-wrap fs14 colf plr44 mt20"  v-if="searchList.dates || searchList.prices">
                                <div class="con_item mr25 flex-box cursor" v-if="searchList.dates"
                                    @click="onSearchClose('dates')">
                                    时间：<span class="fwb">{{ searchList.dates.start ? searchList.dates.start + '-' +
                                        searchList.dates.end : searchList.dates.change_end }}</span>
                                </div>
                                <div class="con_item mr25 flex-box cursor" v-if="searchList.prices"
                                    @click="onSearchClose('prices')">价格：<span class="fwb">{{ searchList.prices.minprice +
                                        '-' +
                                        searchList.prices.maxprice }}</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="plr44 mt25" v-if="orderList.length > 0">
                        <div class="title_box flex-box fs14 col04">
                            <div class="box1 pl30">商品信息</div>
                            <div class="box2 tc">金额</div>
                            <div class="box3 tc">状态</div>
                            <div class="flex-grow-1 tc">操作</div>
                        </div>
                        <template v-if="query.type == 'aftersale'">
                            <div v-for="(order, index) in orderList" :key="index" class="order_box">
                                <div class="item flex-box mt30">
                                    <div class="box1 flex-box pl20">
                                        <img :src="order.goods_image" class="pic" alt="">
                                        <div class="flex-grow-1 pl30">
                                            <div class="fs14 col04 m-ellipsis-l2 mb15">{{ order.goods_title }}</div>
                                            <div class="fs16 col90">订单编号：{{ order.aftersale_sn }}</div>
                                        </div>
                                    </div>
                                    <div class="box2 tc fs14 coleb fwb">{{ order.aftersale_fee }}</div>
                                    <div class="box3 tc fs14 col12 fwb">{{ order.aftersale_status_text }}</div>
                                    <div class="flex-grow-1 flex-box fs14 flex-center">

                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(order, index) in orderList" :key="index" class="order_box">
                                <div class="item flex-box" :class="i > 0 ? 'mt30' : ''" v-for="(item, i) in order.items"
                                    :key="item.id">
                                    <div class="box1 flex-box pl20">
                                        <img :src="item.goods_image" class="pic" alt="">
                                        <div class="flex-grow-1 pl30">
                                            <div class="fs14 col04 m-ellipsis-l2 mb15">{{ item.goods_title }}</div>
                                            <div class="fs16 col90">订单编号：{{ order.order_sn }}</div>
                                        </div>
                                    </div>
                                    <div class="box2 tc fs14 coleb fwb">{{ i == 0 ? '¥ ' + item.goods_price : '' }}</div>
                                    <div class="box3 tc fs14 col12 fwb">{{ i == 0 ? order.status_text : '' }}</div>
                                    <div class="flex-grow-1 flex-box fs14 flex-center">
                                        <div v-if="i == 0 && order.btns.includes('cancel')" class="go">立即付款</div>
                                        <div v-if="i == 0 && order.btns.includes('pay')" class="cursor underline col04"
                                            @click="toggleCancel(order.id)">取消订单
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="orderList.length == 0" class="nodata fs16 tc">
                        <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                        <div>暂无相关数据</div>
                    </div>
                    <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
    <popup :visible="cancelPop" @close="cancelPop = false">
        <div class="popup">
            <img @click="cancelPop = false" class="close cursor" src="../../../assets/static/icon/jxr_login_close.png"
                alt="" />
            <div class="tc fs32 col27 fwb mb45">订单取消</div>
            <div class="flex-box tips coleb fs18">温馨提示：取消后无法恢复，请谨慎选择。</div>
            <div class="fs20 col90 mb30">请选择取消订单原因</div>
            <div class="scroll_box">
                <div class="mb30" v-for="(item, index) in cancelReasonList" :key="index" @click="onChange(index)">
                    <div class="flex-box cursor" @click="reasonIndex = index">
                        <div class="flex-grow-1 fs20 col27">{{ item.content }}</div>
                        <img class="checked_icon" v-if="reasonIndex == index"
                            src="../../../assets/static/icon/c_check2-on.png" />
                        <img class="checked_icon" v-else src="../../../assets/static/icon/c_check2.png" />
                    </div>
                </div>
            </div>
            <div class="flex-box flex-between btn_box fs20 fwb">
                <div class="btn1 col3d" @click="cancelConfirm()">确定取消</div>
                <div class="btn2 colf" @click="cancelPop = false">暂不取消</div>
            </div>
        </div>
    </popup>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import * as com from '@/utils/common.js'; // 导入公共方法
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "子机构管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        const date = new Date()
        const years = []
        const year = date.getFullYear()
        const months = []
        const month = date.getMonth() + 1
        const days = []
        const day = date.getDate()
        for (let i = 1990; i <= date.getFullYear(); i++) {
            years.push(i)
        }
        for (let i = 1; i <= 12; i++) {
            months.push(i)
        }
        for (let i = 1; i <= 31; i++) {
            days.push(i)
        }
        return {
            years,
            months,
            days,
            userId: 0,
            userInfo: {
                institution: {
                    avatar: '',
                    company_name: '',
                    score: 0
                }
            },
            showStart: false,
            startIndex: -2,
            todayDate: year + '-' + (month < 10 ? '0' + month : month) + '-' + day,
            dates: {
                start: '',
                end: '',
                change_end: year + '-' + (month < 10 ? '0' + month : month) + '-' + day
            },
            activityType: null,
            minprice: '',
            maxprice: '',
            searchList: {
                dates: null,
                prices: null,
                activity_type: null
            }, //搜索条件
            query: {
                order_type: 'general',
                keyword: '',
                type: 'all'
            },
            tab: [{
                id: 'all',
                name: '全部订单'
            },
            {
                id: 'unpaid',
                name: '待付款'
            },
            {
                id: 'nosend',
                name: '待发货'
            },
            {
                id: 'noget',
                name: '待收货'
            },
            {
                id: 'completed',
                name: '已完成'
            },
            {
                id: 'aftersale',
                name: '退款/售后'
            },
            ],
            orderList: [],//订单列表
            searchData: {
                dates: [],
                activity: []
            },
            priceIndex: -1,
            timeIndex: -1,
            page: 1,
            sumCount: 0,
            perCount: 10,
            cancelPop: false,
            cancelReasonList: [
                { id: 1, content: "不想要了" },
                //{id:2,content:"拍错地址"},
                { id: 3, content: "拍错产品" },
            ],
            reasonIndex: -1,
            cancelId: -1,
            filter: false,
        };
    },
    created() {
        this.userId = this.$route.query.id;
        this.getInstDetail();
        this.getOrderList(this.page);
        this.getSearchData();
    },
    methods: {
        async getSearchData() {
            this.searchData = await com.getOrderActivity();
        },
        // 触发日期选择器
        openDatePicker(event) {
            event.target.showPicker(); // 仅在支持的浏览器中有效
        },
        // 子机构详情
        getInstDetail() {
            this.$api.getInstDetail({ user_id: this.userId }).then(res => {
                if (res.code == 1) {
                    this.userInfo = res.data;
                }
            }).catch(err => {
                console.log(err)
            })
        },

        //普通订单-活动订单切换
        onActivityChange(orderType) {
            this.query.order_type = orderType;
            this.getOrderList(1);
        },
        //筛选-活动类型
        onShift(activityType) {
            this.activityType = activityType == this.activityType ? null : activityType;
        },
        //自定义时间-中间值 
        dateChange(index) {
            this.startIndex = index;
            if (index >= 0) {
                let dates = this.searchData.dates;
                this.dates.start = dates[index].start;
                this.dates.end = dates[index].end;
                this.dates.change_end = ''; //change日期置空;
            } else {
                this.dates.change_end = this.todayDate; //change日期初始化;
                this.dates.start = '';
                this.dates.end = '';
            }
            this.showStart = false;
        },
        //切换状态
        chooseNav(type) {
            this.query.type = type;
            this.getOrderList(this.page);
        },
        // 获取订单详情
        getOrderList(page) {
            if (this.query.type == 'aftersale') {
                this.getAfterSale(page);
            } else {
                this.getInstDetailOrder(page);
            }
        },
        // 子机构订单详情
        getInstDetailOrder(page) {
            this.query.user_id = this.userId;
            this.query.page = page;
            this.$api.getInstDetailOrder({ ...this.query }).then(res => {
                if (res.code) {
                    this.sumCount = res.data.total;
                    this.perCount = res.data.per_page;
                    this.orderList = res.data.data;
                }
            })
        },
        // 售后订单
        getAfterSale(page) {
            let query = this.query;
            let searchList = this.searchList;
            if (searchList.dates) {
                if (searchList.dates.change_end) {
                    query.start = '';
                    query.end = '';
                    query.change_end = searchList.dates.change_end;
                } else {
                    query.change_end = '';
                    query.start = searchList.dates.start;
                    query.end = searchList.dates.end;
                }
            } else {
                query.change_end = '';
                query.start = '';
                query.end = '';
            }
            if (searchList.prices) {
                query.minprice = searchList.prices.minprice;
                query.maxprice = searchList.prices.maxprice;
            } else {
                query.minprice = '';
                query.maxprice = '';
            }
            query.activity_type = searchList.activity_type ? searchList.activity_type : '';
            this.query.page = page;
            this.$api.getAfterSale({ ...this.query }).then(res => {
                if (res.code) {
                    this.sumCount = res.data.total;
                    this.perCount = res.data.per_page;
                    this.orderList = res.data.data;
                }
            })
        },
        // 价格排序
        priceSort(index) {
            this.priceIndex = index;
            if (index == 0) {
                this.query.sort = "";
                this.query.order = "";
            } else if (index == 1) {
                this.query.sort = "createtime";
                this.query.order = "desc";
            }
            else if (index == 2) {
                this.query.sort = "createtime";
                this.query.order = "asc";
            }
            this.getOrderList(1);
        },
        // 价格排序
        timeSort(index) {
            this.timeIndex = index;
            if (index == 0) {
                this.query.sort = "";
                this.query.order = "";
            } else if (index == 1) {
                this.query.sort = "pay_fee";
                this.query.order = "desc";
            }
            else if (index == 2) {
                this.query.sort = "pay_fee";
                this.query.order = "asc";
            }
            this.getOrderList(1);
        },
        //关键词搜索
        searchOrder() {
            this.getOrderList(1);
        },
        // 翻页
        pageTurn(e) {
            if (this.query.type == 'aftersale') {
                this.refreshAftersale(e + 1);
            } else {
                this.getOrderList(e + 1);
            }
        },
        //删除某个条件
        onSearchClose(field) {
            this.searchList[field] = null;
            if (field == 'dates') {
                this.dates = {
                    start: '',
                    end: '',
                    change_end: this.todayDate
                };
            } else if (field == 'prices') {
                this.activityType = null;
                this.minprice = '';
                this.maxprice = '';
            }

            this.getOrderList(1);
        },
        //筛选确定
        searchSiftConfirm() {
            let dates = this.dates;
            if (dates.start) {
                this.searchList.dates = {
                    start: dates.start,
                    end: dates.end
                };
            } else if (dates.change_end) {
                this.searchList.dates = {
                    change_end: dates.change_end
                };
            } else {
                this.searchList.dates = null;
            }

            this.searchList.activity_type = this.activityType;
            if (this.minprice != '' && this.maxprice != '') {
                this.searchList.prices = {
                    minprice: this.minprice,
                    maxprice: this.maxprice
                }
            } else if (this.minprice == '' || this.maxprice == '') {
                this.searchList.prices = null;
            }
            this.getOrderList(1);
        },
        // 
        // 取消订单
        toggleCancel(orderId) {
            this.cancelId = orderId;
            this.cancelPop = true;
        },
        // 确认取消
        sureCancel() {
            let that = this;
            that.$api.cancelOrder({
                id: that.cancelId,
                reason: that.cancelReasonList[that.reasonIndex].content,
            }.then(res => {
                if (res.code == 1) {
                    that.$message({
                        customClass: 'custom-message',
                        message: '删除成功',
                        type: 'success',
                        duration: 3000,
                    })
                }
            })).catch(err => {
                console.log(err);
            })
        }
    },
};
</script>

<style lang="less" scoped>
.w100 {
    width: 100vw;
}

.pl152 {
    padding-left: 196px;
}

.part_r {
    .sort {
        width: 108px;
        height: 44px;
        background: #1275FF;
        border-radius: 6px;
        font-weight: 500;
        margin-left: auto;

        &::after {
            content: "";
            display: block;
            width: 17px;
            height: 17px;
            background: url('../../../assets/static/icon/c_sort.png') no-repeat center;
            background-size: 100%;
            margin-left: 6px;
        }
        &.on::after{
            background-image:  url('../../../assets/static/icon/c_sort-on.png');
        }
    }

    .top_box {
        width: 100%;
        background: #fff;
        margin-bottom: 14px;

        .company_box {
            height: 214px;
            padding-left: 52px;

            .company_img {
                width: 100px;
                height: 100px;
                display: block;
                margin-right: 20px;
                border-radius: 50%;
                object-fit: cover;
            }

            .company_name {
                color: #272727;
                letter-spacing: 1.2px;
            }

            i {
                width: 135px;
                height: 60px;
                display: block;
                background-repeat: no-repeat;
                background-size: 100%;
                background-position: center;

                &.vip1 {
                    background-image: url("/src/assets/static/icon/c_vip1.png");
                }

                &.vip2 {
                    background-image: url("/src/assets/static/icon/c_vip2.png");
                }

                &.vip3 {
                    background-image: url("/src/assets/static/icon/c_vip3.png");
                }
            }
        }

    }

    .plr44 {
        padding-left: 44px;
        padding-right: 44px;
    }

    .bottom_box {
        padding: 41px 0 55px;
        background: #fff;

        .input_box {
            width: 468px;
            height: 40px;
            border-radius: 8px;
            border: 2px solid #3d7efe;
            padding-left: 20px;

            &::before {
                content: "";
                display: block;
                background: url("/src/assets/static/icon/c_search.png") no-repeat center;
                background-size: 100%;
                width: 22px;
                height: 22px;
                margin-right: 10px;
            }

            input {
                height: 52px;
            }

            .search_btn {
                width: 80px;
                height: 40px;
                border-radius: 8px;
                background: #1275ff;
                text-align: center;
                line-height: 40px;
                margin: -1px -1px 0 0;
                color: #ffffff;
                font-weight: 400;
                letter-spacing: 4.090909px;
            }
        }

        .back::before {
            content: "";
            display: block;
            width: 27px;
            height: 24px;
            background: url('/src/assets/static/icon/c_back.png') no-repeat center;
            background-size: 100%;
            margin-right: 10px;
        }

        .type {
            margin-right: 40px;
            color: #040404;

            & span:hover,
            &.active span {
                color: #3D7EFE;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .condition_box {
            background: #FBFCFD;
        }

        .order_status {
            height: 50px;
            border-bottom: 1px solid rgba(98, 134, 171, 0.4);

            .item {
                margin-right: 88px;
                line-height: 50px;
                cursor: pointer;

                &.active,
                &:hover {
                    color: #1275FF;
                    font-weight: bold;
                    position: relative;

                    &::after {
                        content: "";
                        display: block;
                        width: 100%;
                        height: 4px;
                        background: #1275FF;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                }
            }
        }

        .select_box {
            width: 170px;
            border-radius: 8px;
            border: 1px solid rgba(98, 134, 171, 0.2);
            padding: 0 24px;
            margin-right: 63px;
        }

        .select_box .select {
            height: 38px;
        }

        .select_box .select::after {
            content: "";
            display: block;
            background: url('/src/assets/static/icon/c_arrowd.png') no-repeat center;
            background-size: 100%;
            width: 16px;
            height: 16px;
        }

        .data_list {
            max-height: 300px;
            overflow-y: scroll;
            position: absolute;
            top: 40px;
            left: 0;
            right: 0;
            background-color: #fff;
            border-radius: 0 0 8px 8px;
            display: none;
            border: 1.6px solid rgba(98, 134, 171, 0.2);
        }

        .data_list.show {
            display: block;
        }

        .data_list .item {
            line-height: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 24px;
        }

        .data_list .item:hover {
            background: #1275FF;
            color: #fff;
        }

        .date_picker {
            width: 200px;
            background: rgba(150, 150, 150, 0.06);
            border-radius: 8px;
            position: relative;
            line-height: 40px;
            text-align: center;

            .input_time {
                width: 100%;
                height: 100%;
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                cursor: pointer;
            }

        }

        .line {
            width: 66px;
            height: 2px;
            background: #DEDEDE;
            margin: 0 25px;
        }

        .go {
            width: 108px;
            line-height: 40px;
            background: #1275FF;
            border-radius: 6px;
            text-align: center;
            color: #fff;

            &.shai {
                margin-left: auto;
            }
        }

        .title_box {
            width: 1000px;
            height: 50px;
            background: #FAFCFF;
        }

        .order_box {
            padding: 30px 0;
            border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        }

        .box1 {
            width: 426px;

            .pic {
                width: 94px;
                height: 94px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid rgba(98, 134, 171, 0.2);
            }
        }

        .box2 {
            width: 150px;
        }

        .box3 {
            width: 100px;
        }

        .col04.underline {
            margin: 0 28px;
        }
    }
}

.data_list {
    z-index: 10;
}

.con_item {
    height: 58px;
    background: #3D7EFE;
    border-radius: 8px;
    padding: 0 16px 0 23px;

    &::after {
        content: "";
        display: block;
        background: url('../../../assets/static/icon/c_delete.png') no-repeat center;
        background-size: 100%;
        width: 22px;
        height: 22px;
        margin-left: 13px;
    }
}

.popup {
    padding: 20px 26px 65px;
    width: 500px;
    background: #ffffff;
    box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.27);
    border-radius: 26px;

    .close {
        width: 34px;
        height: 34px;
        display: block;
        object-fit: contain;
        margin-left: auto;
        margin-right: 0;
        margin-bottom: 8px;
    }

    .tips {
        width: 100%;
        height: 48px;
        background: rgba(235, 63, 37, 0.06);
        border-radius: 8px;
        margin: 15px 0 30px;

        &::before {
            content: "";
            display: block;
            width: 18px;
            height: 18px;
            background: url('/src/assets/static/icon/c_wait.png') no-repeat center;
            background-size: 100%;
            margin: 0 17px 0 20px;
        }
    }

    .checked_icon {
        width: 30px;
        height: 30px;
    }


    .btn_box {
        margin-top: 43px;

        div {
            width: 170px;
            height: 60px;
            border-radius: 10px;
            border: 2px solid #D2D2D2;
            line-height: 56px;
            text-align: center;
        }

        .btn2 {
            background: #3D7EFE;
            border-color: #3D7EFE;
        }
    }
}
.h40{
    height:40px;
}
</style>
